import Vue from 'vue'
import Router from 'vue-router'
import Layout from './views/layout/Layout.vue'
import AppMain from './views/layout/components/AppMain.vue'
import Preview from './views/report/components/preview.vue'
import PreviewSlide from './views/report/components/previewSlide'
import notFound from './components/404.vue'

Vue.use(Router)
const originalPush = Router.prototype.push
Router.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}

const router = new Router({
  // mode: 'history',
  // base: process.env.BASE_URL,
  routes: [
    {
      path: '/preview',
      name: 'preview',
      component: Preview
    },
    {
      path: '/previewSlide',
      name: 'previewSlide',
      component: PreviewSlide
    },
    {
      path: '/',
      component: Layout,
      redirect: '/reports',
      meta: { title: '报告中心', icon: 'fa fa-file-text', fa: 'fas', roles: [1, 21, 22, 23] },
      children: [{
        path: '/reports',
        name: 'ReportList',
        component: () => import('@/views/report/index'),
        meta: { title: '报告库', icon: 'fa fa-file-text', fa: 'fas' }
      },
      {
        path: '/reports/report',
        // redirect: '/reports/report/brief',
        name: 'EditReport',
        component: AppMain,
        meta: { title: '编撰报告', icon: 'fa fa-recycle', fa: 'fas', roles: [1, 22, 23] },
        children: [
          {
            path: '/reports/report/briefLog',
            name: 'EditReportLog',
            hidden: true,
            component: () => import('@/views/report/log'),
            meta: { title: '日志', icon: 'fa fa-recycle', fa: 'fas' }
          },
          // {
          //   path: '/reports/report/briefPDF',
          //   name: 'EditReportPDF',
          //   hidden: true,
          //   component: () => import('@/views/report/pdf'),
          //   meta: { title: '报告关联PDF', icon: 'fa fa-recycle', fa: 'fas' }
          // },
          {
            path: '/reports/report/brief',
            name: 'EditReportBrief',
            // hidden: true,
            component: () => import('@/views/report/brief'),
            meta: { title: '新建报告', icon: 'fa fa-recycle', fa: 'fas' }
          },
          {
            path: '/reports/report/outline',
            name: 'EditReportOutline',
            hidden: true,
            component: () => import('@/views/report/outline'),
            meta: { title: '编辑目录', icon: 'fa fa-recycle', fa: 'fas' }
          },
          {
            path: '/reports/report/glossary',
            name: 'EditReportGlossary',
            hidden: true,
            component: () => import('@/views/report/glossary'),
            meta: { title: '名词解释', icon: 'fa fa-recycle', fa: 'fas' }
          },
          {
            path: '/reports/report/content',
            name: 'EditReportContent',
            hidden: true,
            component: () => import('@/views/report/content'),
            meta: { title: '编辑报告', icon: 'fa fa-recycle', fa: 'fas' }
          },
          {
            path: '/reports/report/slide',
            name: 'EditReportSlide',
            hidden: true,
            component: () => import('@/views/report/slide'),
            meta: { title: '编辑报告', icon: 'fa fa-recycle', fa: 'fas' }
          }
        ]
      }]
    },
    {
      path: '/article',
      component: Layout,
      children: [{
        path: '/article/index',
        name: 'Article',
        component: () => import('@/views/article/Article'),
        meta: {
          title: '文章管理',
          icon: 'fa fa-file-text-o',
          fa: 'fas',
          roles: [1, 51, 52, 53]
        }
      }]
    },
    {
      path: '/video',
      component: Layout,
      children: [{
        path: '/video/index',
        name: 'video',
        component: () => import('@/views/video'),
        meta: { title: '解说', icon: 'fa fa-vimeo', fa: 'fas', roles: [1, 31, 32, 33] }
      }]
    },
    // {
    //   path: '/size',
    //   component: Layout,
    //   redirect: '/size',
    //   meta: { title: '数说Pro', icon: 'fa fa-area-chart', fa: 'fas', roles: [1, 21, 22, 23] },
    //   children: [{
    //     path: '/size/SizePro',
    //     name: 'sizePro',
    //     component: () => import('@/views/size/SizePro'),
    //     meta: { title: '数说', icon: 'fa fa-area-chart', fa: 'fas' }
    //   }, {
    //     path: '/size/SizePro/From',
    //     name: 'sizeProFrom',
    //     hidden: true,
    //     component: () => import('@/views/size/components/index'),
    //     meta: { title: '录入数说', icon: 'fa fa-area-chart', fa: 'fas' }
    //   }]
    // },
    // {
    //   path: '/table',
    //   component: Layout,
    //   children: [{
    //     path: '/table/index',
    //     name: 'Table',
    //     component: () => import('@/views/table/Table'),
    //     meta: { title: '表说', icon: 'fa fa-table', fa: 'fas', roles: [1, 21, 22, 23] }
    //   }]
    // },

    // {
    //   path: '/quote',
    //   component: Layout,
    //   children: [{
    //     path: '/quote/index',
    //     name: 'Quote',
    //     component: () => import('@/views/quote/Quote'),
    //     meta: { title: '专家说', icon: 'fa fa-user-plus', fa: 'fas', roles: [1, 21, 22, 23] }
    //   }]
    // },
    {
      path: '/sensitiveWord',
      component: Layout,
      children: [
        {
          path: '/sensitiveWord',
          name: 'sensitiveWord',
          component: () => import('@/views/sensitiveWord/index.vue'),
          meta: { title: '敏感词', icon: 'el-icon-brush', fa: 'fas', roles: [1] }
        }
      ]
    },
    {
      path: '/team',
      component: Layout,
      meta: { title: '团队', icon: 'fa fa-handshake-o', fa: 'fas' },
      children: [{
        path: '/team/team',
        name: 'Team',
        component: () => import('@/views/team/Team'),
        meta: { title: '厂牌', icon: 'fa fa-users', fa: 'fas' }
      }, {
        path: '/team/individual',
        name: 'Individual',
        component: () => import('@/views/team/Individual'),
        meta: { title: '个人', icon: 'fa fa-user', fa: 'fas' }
      }]
    },
    {
      path: '/system',
      component: Layout,
      meta: { title: '系统', icon: 'fa fa-th-large', fa: 'fas' },
      children: [{
        path: '/system/recycler',
        name: 'Recycler',
        component: () => import('@/views/recycler/Recycler'),
        meta: { title: '回收站', icon: 'fa fa-recycle', fa: 'fas' }
      }, {
        path: '/system/export',
        name: 'Export',
        component: () => import('@/views/export/Export'),
        meta: { title: '同步', icon: 'fa fa-refresh', fa: 'fas', roles: [1] }
      }, {
        path: '/system/ocr',
        name: 'Ocr',
        component: () => import('@/views/ocr/index'),
        meta: { title: 'ocr', icon: 'fa fa-gg', fa: 'fas' }
      }, {
        path: '/applyLog',
        name: 'ApplyLog',
        component: () => import('@/views/apply/applyLog'),
        meta: { title: '申请日志', icon: 'fa fa-user', fa: 'fas', roles: [1] }
      }]
    },
    {
      path: '/staff',
      component: Layout,
      children: [{
        path: '/staff/index',
        name: 'Staff',
        component: () => import('@/views/staff/index'),
        meta: { title: '员工管理', icon: 'fa fa-user-o', fa: 'fas', roles: [1] }
      }]
    },
    {
      path: '/login',
      component: Layout,
      children: [{
        path: '/login',
        name: 'Login',
        component: () => import('./components/Login.vue'),
        meta: { title: '退出', icon: 'fa fa-sign-out', fa: 'fas' }
      }]
    },
    {
      path: '*',
      name: 'notFound',
      component: notFound
    }, {
      path: '/apply',
      name: 'Apply',
      component: () => import('@/views/apply/index')
    }
  ]
})
// router.beforeEach((to, from, next) => {
//   if (localStorage.getItem('passport')) {
//     next()
//   } else {
//     if (to.path === '/login') {
//       next()
//     } else {
//       next('/login')
//     }
//   }
// })
export default router
